(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["purchase-options"] && !Shopify.designMode) return;
  try {
    class PurchaseOptionsComponent extends HTMLElement {
    #imageAbortController;

    connectedCallback() {
      this.purchaseType = this.dataset.initialType || 'one-time';

      const checkedInput = this.querySelector('.supply-option input[type="radio"]:checked');
      const checkedOption = checkedInput?.closest('.supply-option');
      this.selectedVariantId = checkedOption ? parseInt(checkedOption.dataset.variantId) : null;

      this.#bindEvents();
      this.#update();
    }

    #bindEvents() {
      this.querySelectorAll('.purchase-type__option input').forEach((input) => {
        input.addEventListener('change', (e) => {
          this.purchaseType = e.target.value;
          this.#update();
        });
      });

      this.querySelectorAll('.supply-option input[type="radio"]').forEach((input) => {
        input.addEventListener('change', (e) => {
          this.selectedVariantId = parseInt(e.target.closest('.supply-option').dataset.variantId);
          this.#updateUrl();
          this.#update();
          this.#updateImage();
        });
      });

      this.querySelector('[data-decrease-qty]')?.addEventListener('click', () => this.#adjustQty(-1));
      this.querySelector('[data-increase-qty]')?.addEventListener('click', () => this.#adjustQty(1));
      this.querySelector('[data-quantity-input]')?.addEventListener('input', () => this.#update());
      this.querySelector('form')?.addEventListener('submit', (e) => this.#handleSubmit(e));
    }

    #getQty() {
      const input = this.querySelector('[data-quantity-input]');
      return Math.max(1, parseInt(input?.value) || 1);
    }

    #formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, Shopify.money_format);
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'AUD',
        minimumFractionDigits: 2,
      }).format(cents / 100);
    }

    #update() {
      const selectedOption = this.querySelector(`.supply-option[data-variant-id="${this.selectedVariantId}"]`);

      const subscribeLabel = this.querySelector('.purchase-type__option[data-type="subscribe"]');
      if (subscribeLabel) {
        const subscribeInput = subscribeLabel.querySelector('input[type="radio"]');
        const variantHasSubscription = selectedOption?.dataset.hasSubscription === 'true';
        const shouldDisable = !variantHasSubscription;
        subscribeLabel.classList.toggle('purchase-type__option--disabled', shouldDisable);
        if (subscribeInput) {
          subscribeInput.disabled = shouldDisable;
          if (shouldDisable && this.purchaseType === 'subscribe') {
            this.purchaseType = 'one-time';
            subscribeInput.checked = false;
            const onetimeLabel = this.querySelector('.purchase-type__option[data-type="one-time"]');
            const onetimeInput = onetimeLabel?.querySelector('input[type="radio"]');
            if (onetimeInput) onetimeInput.checked = true;
          }
        }
      }

      const isSubscribe = this.purchaseType === 'subscribe';
      const qty = this.#getQty();

      this.querySelectorAll('.purchase-type__option').forEach((label) => {
        label.classList.toggle('purchase-type__option--active', label.dataset.type === this.purchaseType);
      });

      this.querySelectorAll('.supply-option').forEach((option) => {
        option.classList.toggle(
          'supply-option--selected',
          parseInt(option.dataset.variantId) === this.selectedVariantId
        );

        const badgeEl = option.querySelector('[data-option-badge]');
        if (badgeEl) {
          const badgeText = isSubscribe ? option.dataset.subscribeBadge : option.dataset.onetimeBadge;
          badgeEl.textContent = badgeText || '';
          badgeEl.hidden = !badgeText;
          option.classList.toggle('supply-option--has-badge', !!badgeText);
        }

        const priceEl = option.querySelector('[data-option-price]');
        if (priceEl) {
          const priceCents = parseInt(
            isSubscribe ? option.dataset.subscribePriceCents : option.dataset.oneTimePriceCents
          );
          priceEl.textContent = this.#formatMoney(priceCents * qty);
        }

        const compareEl = option.querySelector('[data-option-compare]');
        if (compareEl) {
          const priceCents = parseInt(
            isSubscribe ? option.dataset.subscribePriceCents : option.dataset.oneTimePriceCents
          );
          const compareCents = parseInt(
            isSubscribe ? option.dataset.subscribeCompareCents : option.dataset.oneTimeCompareCents
          );
          const showCompare = compareCents > priceCents;
          compareEl.textContent = showCompare ? this.#formatMoney(compareCents * qty) : '';
          compareEl.hidden = !showCompare;
        }
      });

      const variantInput = this.querySelector('[data-variant-id-input]');
      if (variantInput) variantInput.value = this.selectedVariantId;

      const sellingPlanInput = this.querySelector('[data-selling-plan-input]');
      if (sellingPlanInput) {
        sellingPlanInput.value =
          isSubscribe && selectedOption?.dataset.sellingPlanId ? selectedOption.dataset.sellingPlanId : '';
      }

      const ctaTextEl = this.querySelector('[data-cta-text]');
      if (ctaTextEl) ctaTextEl.textContent = isSubscribe ? this.dataset.subscribeCta : this.dataset.onetimeCta;

      const ctaPriceEl = this.querySelector('[data-cta-price]');
      if (ctaPriceEl && selectedOption) {
        const priceCents = parseInt(
          isSubscribe ? selectedOption.dataset.subscribePriceCents : selectedOption.dataset.oneTimePriceCents
        );
        ctaPriceEl.textContent = this.#formatMoney(priceCents * qty);
      }

      const bullets = this.querySelector('[data-subscribe-bullets]');
      if (bullets) bullets.hidden = !isSubscribe;

      const ctaBtn = this.querySelector('[data-cta-button]');
      if (ctaBtn && selectedOption) {
        ctaBtn.disabled = selectedOption.dataset.available !== 'true';
      }
    }

    #updateImage() {
      if (!this.selectedVariantId) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.selectedVariantId);

      this.#imageAbortController?.abort();
      this.#imageAbortController = new AbortController();

      fetch(url.toString(), { signal: this.#imageAbortController.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const mediaGallery = document.querySelector('media-gallery');
          const target = mediaGallery?.closest('.shopify-section, dialog');
          if (!target) return;
          target.dispatchEvent(
            new CustomEvent('variant:update', {
              detail: { data: { html: doc } },
            })
          );
        })
        .catch((err) => {
          if (err.name !== 'AbortError') console.error(err);
        });
    }

    #updateUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.selectedVariantId);
      history.replaceState({}, '', url.toString());
    }

    #adjustQty(delta) {
      const input = this.querySelector('[data-quantity-input]');
      if (!input) return;
      input.value = Math.max(parseInt(input.min) || 1, (parseInt(input.value) || 1) + delta);
      this.#update();
    }

    #handleSubmit(e) {
      e.preventDefault();
      const form = e.target;
      const btn = this.querySelector('[data-cta-button]');
      const formData = new FormData(form);

      formData.delete('purchase_type');
      formData.delete('supply_variant');
      if (!formData.get('selling_plan')) formData.delete('selling_plan');

      const sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
        sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) formData.set('sections', sectionIds.join(','));

      if (btn) btn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((r) => {
          if (!r.ok) throw new Error('Cart add failed');
          return r.json();
        })
        .then((response) => {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: response,
                sourceId: this.id,
                data: {
                  sections: response.sections,
                  productId: this.dataset.productId,
                  source: 'purchase-options-component',
                },
              },
            })
          );
        })
        .catch(() => form.submit())
        .finally(() => {
          if (btn) btn.removeAttribute('aria-busy');
        });
    }
  }

  if (!customElements.get('purchase-options-component')) {
    customElements.define('purchase-options-component', PurchaseOptionsComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
